import Cookies from 'js-cookie';

export const META_PIXEL_ALLOWED_HOSTS = ['air.inc', 'www.air.inc', 'app.air.inc'];

export const isMetaPixelAllowedHost = (_hostname: string): boolean => META_PIXEL_ALLOWED_HOSTS.includes(_hostname);

const FBC_MAX_AGE_DAYS = 90;

export const captureFbclidToCookie = (): void => {
  if (typeof window === 'undefined') {
    return;
  }
  const fbclid = new URLSearchParams(window.location.search).get('fbclid');

  if (!fbclid) {
    return;
  }
  const existing = Cookies.get('_fbc');

  if (existing?.endsWith(`.${fbclid}`)) {
    return;
  }
  const domain = window.location.hostname.endsWith('air.inc') ? '.air.inc' : undefined;
  Cookies.set('_fbc', `fb.1.${Date.now()}.${fbclid}`, {
    expires: FBC_MAX_AGE_DAYS,
    path: '/',
    sameSite: 'Lax',
    domain,
  });
};
